<!-- begin breadcrumb -->
<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Grupos</li>
</ol>
<!-- end breadcrumb -->
<!-- begin page-header -->
<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Grupos</small></h1>
<!-- end page-header -->

<div class="scrollable">
    <panel [noButton]="true">
        <h5>Listado de Grupos</h5>
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <div class="d-flex gap-2 flex-wrap align-items-center">
                <select class="form-select form-select-sm" style="width: auto; min-width: 130px;"
                    [(ngModel)]="selectedYear" (change)="onYearChange()">
                    <option [ngValue]="null">Todos los años</option>
                    @for(y of years; track y){
                    <option [ngValue]="y">{{y}}</option>
                    }
                </select>
                <input type="text" class="form-control form-control-sm" style="width: auto; min-width: 220px;"
                    placeholder="Escriba para buscar" [(ngModel)]="nameGroup" (keyup)="filterGroup()">
                <div class="form-check form-switch d-flex align-items-center gap-2 ms-2">
                    <input class="form-check-input" type="checkbox" role="switch" id="showDisabled"
                        [(ngModel)]="showDisabled" (change)="filterGroup()">
                    <label class="form-check-label fw-600" for="showDisabled">Mostrar deshabilitados</label>
                </div>
            </div>
            <button class="btn btn-success btn-xs flex-shrink-0" (click)="editGroup = null; open(modalNewGroup)">
                <i class="fas fa-plus"></i> Nuevo</button>
        </div>
        <div class="row modal-body mt-3 p-3">
            <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead class="fixed-header">
                    <tr>
                        <th>N°</th>
                        <th>Nombre</th>
                        <th class="col-1 text-center">Campo</th>
                        <th class="col-1 text-center">Póliza</th>
                        <th class="col-1 text-center">Año</th>
                        <th class="col-1 text-center">Asegurados</th>
                        <!-- @if(permissions?.search.edit){ -->
                        <th class="text-center"><i class="fas fa-cogs"></i></th>
                        <!-- } -->
                    </tr>
                </thead>
                <tbody>
                    @if(listGroups.length > 0){
                    @for(g of listGroups; track g;let i = $index){
                    <tr [ngClass]="{'table-danger': g.enabled === false}">
                        <td>{{ i + 1 }}</td>
                        <td>{{g.name | uppercase}}</td>
                        <td class="text-center">{{g.campus?.acronym}}</td>
                        <td class="text-center">{{g.policy?.code}}</td>
                        <td class="text-center">{{g.year}}</td>
                        <td class="text-center">{{g.insuredCount || 0}}</td>
                        <!-- @if(permissions?.search.edit){ -->
                        <td class="text-center">
                            <button class="btn btn-warning btn-xs btn-rounded"
                                (click)="editGroup = g; open(modalNewGroup)"><i class="fas fa-edit"></i></button>
                        </td>
                        <!-- } -->

                    </tr>
                    }
                    }@else {
                    <td colspan="7">No hay registros para mostrar.</td>
                    }
                </tbody>
            </table>
            </div>
        </div>
    </panel>
</div>




<ng-template #modalNewGroup>
    <app-modal-group-of-policies [group]="editGroup"
        (group_save)="getGroupOfPolicies($event)" [permissions]="permissions"></app-modal-group-of-policies>
</ng-template>